import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { BTN, INPUT, errMsg, fmt } from "./crmUtil";

const LABEL = { activity: "", task: "Task created", task_done: "Task done", site_visit: "Site visit" };

// Activity timeline: calls / notes / emails / meetings logged by hand, plus tasks and site visits on this record.
export default function ActivityTimeline({ entity, id }) {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ kind: "call", summary: "", direction: "" });
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get(`/crm/${entity}/${id}/timeline`).then((r) => setItems(r.data)).catch((e) => setErr(errMsg(e))), [entity, id]);
  useEffect(() => { load(); }, [load]);
  const log = async (e) => {
    e.preventDefault(); setErr("");
    try {
      await api.post(`/crm/${entity}/${id}/activities`, { kind: form.kind, summary: form.summary.trim(), ...(form.direction && { direction: form.direction }) });
      setForm({ ...form, summary: "" }); load();
    } catch (x) { setErr(errMsg(x)); }
  };
  return (
    <section className="border border-erf-borderCream rounded bg-white p-4 space-y-3" data-testid="activity-timeline" aria-labelledby="timeline-title">
      <h3 id="timeline-title" className="font-display font-semibold">Activity</h3>
      <form onSubmit={log} className="grid gap-2 sm:grid-cols-[9rem_9rem_1fr_auto] sm:items-end">
        <label htmlFor="act-kind" className="text-sm">Type
          <select id="act-kind" value={form.kind} onChange={(e) => setForm({ ...form, kind: e.target.value })} className={INPUT} data-testid="act-kind">
            {["call", "note", "email", "meeting"].map((k) => <option key={k} value={k}>{k}</option>)}
          </select>
        </label>
        <label htmlFor="act-direction" className="text-sm">Direction
          <select id="act-direction" value={form.direction} onChange={(e) => setForm({ ...form, direction: e.target.value })} className={INPUT} data-testid="act-direction">
            <option value="">—</option><option value="outbound">Outbound</option><option value="inbound">Inbound</option>
          </select>
        </label>
        <label htmlFor="act-summary" className="text-sm">Summary<input id="act-summary" value={form.summary} onChange={(e) => setForm({ ...form, summary: e.target.value })} maxLength={300} className={INPUT} data-testid="act-summary" /></label>
        <button type="submit" disabled={form.summary.trim().length < 2} className={`${BTN} bg-erf-dark text-white`} data-testid="act-log">Log</button>
      </form>
      <p className="text-xs text-erf-dark/60">Logged by hand. Emails and calls are not captured automatically.</p>
      {err && <p role="alert" className="text-sm text-red-700" data-testid="timeline-error">{err}</p>}
      {items.length === 0 ? <p className="text-xs font-mono text-erf-dark/60" data-testid="timeline-empty">Nothing logged yet.</p> : (
        <ol className="space-y-2">
          {items.map((i) => (
            <li key={`${i.type}-${i.id}`} className="border-l-2 border-erf-gold pl-3" data-testid={`timeline-${i.type}-${i.id}`}>
              <p className="text-sm font-nav">{i.type === "activity" ? `${i.kind}${i.direction ? ` (${i.direction})` : ""}: ${i.summary}` : `${LABEL[i.type]}: ${i.title || i.kind || ""}`}</p>
              <p className="text-xs text-erf-dark/60">{fmt(i.at)}</p>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
